module.exports = __webpack_public_path__ + "img/CustomOrder.f42aafbb.png";